import React from 'react'

import {
    GridContainer,
    GridItem1,
    GridItem3xs1,
    GridItem4,
    GridItem4xs6,
    GridItem6,
    GridItem8,
    GridItem8xs10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelectDestaque,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    TipoEducacao,
    IconButtonClearEntradaDadosEducacao,
    TipoPeriodicidadePagto,
    Valor,
    ValorAcumulado,
    IdadeInicial,
    IdadeFinal,
    TemSeguro,
    TipoSegurado,
    GrupoDespesa,
    Observacao,
} from './DespesasCompEducacao'



const DespesasFormEducacaoItem = ({ values, handleChange, setFieldValue, arrayHelpers, item, ind, simplificado }) => {

    return (
        <CardGridEntradaDados>
            <CardGridDivHeaderEntradaDados>
                <GridContainer>
                    <GridItem8xs10>
                        <TipoEducacao
                            TextFieldNumberSelectTipoEducacao={
                                TextFieldNumberSelectDestaque
                            }
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem8xs10>
                    <GridItem3xs1 />
                    <GridItem1>
                        <IconButtonClearEntradaDadosEducacao
                            values={values}
                            setFieldValue={setFieldValue}
                            ind={ind}
                            arrayHelpers={arrayHelpers}
                            simplificado={simplificado}
                        />
                    </GridItem1>
                </GridContainer>
            </CardGridDivHeaderEntradaDados>

            <CardGridDivBodyEntradaDados
                style={{
                    display: 
                        item.tipoEducacao
                            ? "block"
                            : "none"
                }} 
            >
                <GridContainer>
                    <GridItem4xs6>
                        <TipoPeriodicidadePagto
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem4xs6>
                    <GridItem4xs6>
                        <Valor
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem4xs6>
                    {item.valorAcumulado !== 0  && (
                        <GridItem4xs6>
                            <ValorAcumulado
                                item={item}
                                ind={ind}
                                handleChange={handleChange} 
                            />
                        </GridItem4xs6>
                    )}
                </GridContainer>

                <GridContainer>
                    <GridItem4xs6>
                        <IdadeInicial
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem4xs6>
                    <GridItem4xs6>
                        <IdadeFinal
                            values={values}
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem4xs6>
                </GridContainer>

                <GridContainer>
                    <GridItem6>
                        <GrupoDespesa
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem6>
                </GridContainer>
                
                <CardGridDividerElementos/>
                
                <GridContainer>
                    <GridItem4>
                        <TemSeguro
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem4>

                    {item.temSeguro === "S" && (
                        <GridItem8>
                            <TipoSegurado
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange} 
                            />
                        </GridItem8>
                    )}
                </GridContainer>

                <CardGridDividerElementos/>

                <GridContainer>
                    <GridItem12>
                        <Observacao
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem12>
                </GridContainer>
            </CardGridDivBodyEntradaDados>
        </CardGridEntradaDados>
    )
}

export default DespesasFormEducacaoItem